export default function (state = {id: ""}, action) {
    switch (action.type) {
        case 'CLEAR_STORE':
            return {id: ""};

        case 'SET_STORE':
            return {id: action.storeId};

        default:
            return state;
    }
}
